export default "__VITE_ASSET__C2UnU1H9__"